module.exports = __webpack_public_path__ + "img/candy.a70b5daf.png";